export const searchForResponse = (responses: any, slug: string) => {
  for (var i = 0; i < responses.length; i++) {
    if (responses[i].slug === slug) {
      return responses[i];
    }
  }
  return null;
};
